// Class year is always a 4-digit graduation year (e.g. "1990", "1991) and never
// free-form text. We render it as a searchable Select fed by this fixed list so
// operators pick a real year instead of typing arbitrary strings.
//
// Values are strings to match the `profiles.class_year` column type
// (string | null in the generated DB types).

// Miami Union Adventist Academy was established in 1917 (see the official seal in
// mobile Crest.tsx and MUAA_FOUNDED), so no graduating class predates it.
const EARLIEST_CLASS_YEAR = 1917

export type ClassYearOption = { value: string; label: string }

/**
 * Years from the current year down to {@link EARLIEST_CLASS_YEAR}, most recent
 * first. Computed at module load so the upper bound stays current without a code
 * change each year.
 */
export const CLASS_YEAR_OPTIONS: ClassYearOption[] = (() => {
  const currentYear = new Date().getFullYear()
  const options: ClassYearOption[] = []
  for (let year = currentYear; year >= EARLIEST_CLASS_YEAR; year--) {
    const value = String(year)
    options.push({ value, label: value })
  }
  return options
})()
